<template>
    <section class="dp-layout">

        <section class="dp-left">
            <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
        </section>

        <section class="dp-right">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="学生" name="0">
                    <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
                    <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
                    <div class="tbl-scroll-host">
                    <el-table height="100%" :data="users" v-loading="listLoading" @selection-change="handleSelectionChange"
                        ref="table" style="width: 100%" class="custom-tbl">
                        <el-table-column type="selection" width="50"></el-table-column>

                        <el-table-column prop="UserName" label="用户名" min-width="100" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="OrderDate" label="就餐日期" width="110" align="center"></el-table-column>
                        <el-table-column prop="DinnerTimeName" label="时段" width="90" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="StartTime" label="开始/结束" width="160" align="center">
                            <template slot-scope="scope">{{ scope.row.StartTime }} - {{ scope.row.EndTime }}</template>
                        </el-table-column>

                        <el-table-column prop="TotalAmount" label="总金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.TotalAmount) }}</template>
                        </el-table-column>
                        <el-table-column prop="DiscountAmount" label="优惠金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.DiscountAmount) }}</template>
                        </el-table-column>
                        <el-table-column prop="ActualPayAmount" label="实付金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.ActualPayAmount) }}</template>
                        </el-table-column>
                        <el-table-column label="取餐状态" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="pickupTagType(scope.row)">{{ getPickupStatus(scope.row) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="OrderStatus" label="状态" width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="scope.row.OrderStatus === 1 ? 'danger' : 'success'">{{
                                    scope.row.OrderStatus
                                        ===
                                        1 ? '已退订' : '正常' }}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="CreateTime" label="订餐时间" width="160"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="160" align="center">
                            <template slot-scope="scope">
                                <div class="order-action">
                                    <el-button v-if="scope.row.OrderStatus !== 1" @click.stop="handleCancelOrderStat(scope.row)"
                                        type="danger" plain size="mini">退订</el-button>
                                    <el-button @click.stop="openDetail(scope.row)" type="primary" plain size="mini">查看详情</el-button>
                                </div>
                            </template>
                        </el-table-column>

                    </el-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="教师" name="1">

                    <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
                    <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
                    <div class="tbl-scroll-host">
                    <el-table height="100%" :data="users" v-loading="listLoading" @selection-change="handleSelectionChange"
                        ref="table" style="width: 100%" class="custom-tbl">
                        <el-table-column type="selection" width="50"></el-table-column>

                        <el-table-column prop="UserName" label="用户名" min-width="100" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="OrderDate" label="就餐日期" width="110" align="center"></el-table-column>
                        <el-table-column prop="DinnerTimeName" label="时段" width="90" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="StartTime" label="开始/结束" width="160" align="center">
                            <template slot-scope="scope">{{ scope.row.StartTime }} - {{ scope.row.EndTime }}</template>
                        </el-table-column>

                        <el-table-column prop="TotalAmount" label="总金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.TotalAmount) }}</template>
                        </el-table-column>
                        <el-table-column prop="DiscountAmount" label="优惠金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.DiscountAmount) }}</template>
                        </el-table-column>
                        <el-table-column prop="ActualPayAmount" label="实付金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.ActualPayAmount) }}</template>
                        </el-table-column>
                        <el-table-column label="取餐状态" width="100" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="pickupTagType(scope.row)">{{ getPickupStatus(scope.row) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="OrderStatus" label="状态" width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag size="small" :type="scope.row.OrderStatus === 1 ? 'danger' : 'success'">{{
                                    scope.row.OrderStatus
                                        ===
                                        1 ? '已退订' : '正常' }}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="CreateTime" label="订餐时间" width="160"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="160" align="center">
                            <template slot-scope="scope">
                                <div class="order-action">
                                    <el-button v-if="scope.row.OrderStatus !== 1" @click.stop="handleCancelOrderStat(scope.row)"
                                        type="danger" plain size="mini">退订</el-button>
                                    <el-button @click.stop="openDetail(scope.row)" type="primary" plain size="mini">查看详情</el-button>
                                </div>
                            </template>
                        </el-table-column>

                    </el-table>
                    </div>

                </el-tab-pane>
            </el-tabs>
            <!-- 订餐详情对话框 -->
            <el-dialog title="订餐详情" :visible.sync="detailDialogVisible" :close-on-click-modal="false" width="65%">
                <div v-if="detailLoading" style="text-align:center; padding:20px">加载中...</div>
                <div v-else-if="recordDetail">
                    <div class="record-info">
                        <p class="muted">学生：<strong>{{ recordDetail.UserName }}</strong>&nbsp;&nbsp; 就餐日期：<strong>{{
                            recordDetail.OrderDate }}</strong>&nbsp;&nbsp; 时段：<strong>{{ recordDetail.DinnerTimeName
                                }}</strong>&nbsp;&nbsp; 实付： <strong>{{ formatDecimal(recordDetail.ActualPayAmount)
                                }}</strong></p>
                        <p class="muted">总金额：<strong>{{ formatDecimal(recordDetail.TotalAmount) }}</strong>&nbsp;&nbsp;
                            优惠：<strong>{{ formatDecimal(recordDetail.DiscountAmount) }}</strong>&nbsp;&nbsp; 状态：<el-tag
                                :type="recordDetail.OrderStatus === 1 ? 'danger' : 'success'">{{
                                    recordDetail.OrderStatus === 1 ?
                                        '已退订' : '正常' }}</el-tag></p>
                    </div>

                    <el-table :data="recordDetail.Details || []" style="width: 100%; margin-top:10px" border>
                        <el-table-column prop="SetMealName" label="菜品/套餐" min-width="140" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Quantity" label="数量" width="70" align="center"></el-table-column>

                        <el-table-column prop="PaidQuantity" label="已支付份数" width="100" align="center">
                            <template slot-scope="scope">{{ scope.row.PaidQuantity != null ? scope.row.PaidQuantity : ''
                                }}</template>
                        </el-table-column>
                        <el-table-column prop="PickedQuantity" label="已取餐份数" width="100" align="center">
                            <template slot-scope="scope">{{ scope.row.PickedQuantity != null ? scope.row.PickedQuantity
                                : '' }}</template>
                        </el-table-column>
                        <el-table-column prop="Price" label="单价" width="90" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.Price) }}</template>
                        </el-table-column>
                        <el-table-column prop="Amount" label="总价" width="90" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.Amount) }}</template>
                        </el-table-column>
                        <el-table-column prop="DiscountAmount" label="优惠金额" width="100" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.DiscountAmount) }}</template>
                        </el-table-column>
                        <el-table-column prop="ActualPayAmount" label="实付" width="90" align="right" header-align="right">
                            <template slot-scope="scope">{{ formatDecimal(scope.row.ActualPayAmount) }}</template>
                        </el-table-column>
                        <el-table-column label="媒体" width="160" align="center">
                            <template slot-scope="scope">
                                <oss-media-thumbs v-if="showImage(scope.row.MediaFiles).length > 0"
                                    :media="scope.row.MediaFiles" :max="3" />
                                <div v-else-if="scope.row.MediaFiles" style="word-break:break-all">{{
                                    showImage(scope.row.MediaFiles).join(';') }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Description" label="描述" min-width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column label="取餐明细" width="110" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="mini"
                                    @click.stop="openPickupDetails(scope.row)">查看取餐明细</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="detailDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <!-- 取餐明细对话框 -->
            <el-dialog title="取餐明细" :visible.sync="pickupDialogVisible" :close-on-click-modal="false" width="50%">
                <div v-if="pickupLoading" style="text-align:center; padding:20px">加载中...</div>
                <div v-else>
                    <el-table :data="pickupDetailList || []" style="width:100%" border>
                        <el-table-column prop="PickupQuantity" label="取餐数量" width="90" align="center"></el-table-column>
                        <el-table-column prop="PickupTime" label="取餐时间" width="160">
                            <template slot-scope="scope">{{ scope.row.PickupTime || '' }}</template>
                        </el-table-column>
                        <el-table-column prop="OrderId" label="订单号" min-width="160" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="Operator" label="操作人" width="100" show-overflow-tooltip></el-table-column>
                    </el-table>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="pickupDialogVisible = false">关闭</el-button>
                </div>
            </el-dialog>

            <el-col :span="24" class="toolbar">
                <el-pagination @current-change="handleCurrentChange"
                    :page-size="pageSize" :page-sizes="pageSizes" @size-change="handleSizeChange" :total="total"
                    layout="total, sizes, prev, pager, next, jumper" style="float: right"></el-pagination>
            </el-col>

        </section>

    </section>
</template>

<script>
import util from "../../../util/date";
import { getOrderStatsByDepartment, exportOrderStatsByDepartment, batchCancelOrderStat } from '../../api/modules/catering';
import { getDinnerTimeList } from '../../api/modules/consumption';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            filters: {},
            activeName: "0",
            searchList: (function () {
                const now = new Date();
                const fmt = d => {
                    const y = d.getFullYear();
                    const m = String(d.getMonth() + 1).padStart(2, '0');
                    const day = String(d.getDate()).padStart(2, '0');
                    return `${y}-${m}-${day}`;
                };
                const today = fmt(now);
                const weekAgo = fmt(new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000));
                return [
                    { label: '开始日期', key: 'date', type: 'date', initValue: weekAgo },
                    { label: '结束日期', key: 'endDate', type: 'date', initValue: today },
                    { label: '姓名', key: 'search', type: 'input', placeholder: '姓名模糊搜索' },
                    {
                        label: '取餐状态', key: 'pickupStatus', type: 'select',
                        options: [
                            { label: '全部', value: -1 },
                            { label: '未取餐', value: 0 },
                            { label: '部分取餐', value: 1 },
                            { label: '已取餐', value: 2 }
                        ],
                        initValue: -1
                    },
                    {
                        label: '订单状态', key: 'orderStatus', type: 'select',
                        options: [
                            { label: '全部', value: -1 },
                            { label: '正常', value: 0 },
                            { label: '已退订', value: 1 }
                        ],
                        initValue: -1
                    },
                    {
                        label: '就餐时段', key: 'dinnerTimeId', type: 'select',
                        options: (function () { return this.dinnerTimeOptions || []; }).bind(this),
                        initValue: 0
                    }
                ];
            })(),
            buttonList: [],
            users: [],
            total: 0,
            page: 1,
            listLoading: false,
            sels: [],
            multipleSelection: [],
            currentRow: null,
            pageSize: 10,
            pageSizes: [10, 20, 50, 100],
            DepartmentId: "",
            detailDialogVisible: false,
            recordDetail: null,
            detailLoading: false,
            BaseApiUrl: BaseApiUrl,
            // 取餐明细弹窗
            pickupDialogVisible: false,
            pickupDetailList: [],
            pickupLoading: false,
            dinnerTimeOptions: [{ label: '全部', value: 0 }]
        };
    },
    methods: {
        handleClick(tab, event) {
            this.page = 1;
            this.handleQuery();
        },
        formatDecimal(val) {
            if (val === null || val === undefined || val === '') return '';
            const n = Number(val);
            if (isNaN(n)) return val;
            return n.toFixed(2);
        },
        // 根据 Details 判断取餐状态：全部未取 => 未取餐；全部已取 => 已取餐；混合 => 部分取餐；无明细视为未取餐
        getPickupStatus(row) {
            const details = (row && row.Details) || [];
            if (!Array.isArray(details) || details.length === 0) return '未取餐';
            let anyPicked = false;
            let anyUnpicked = false;
            for (const d of details) {
                const picked = Number(d.PickedQuantity) || 0;
                const qty = Number(d.Quantity) || 0;
                if (picked > 0) anyPicked = true;
                if (picked < qty) anyUnpicked = true;
            }
            if (!anyPicked && anyUnpicked) return '未取餐';
            if (anyPicked && !anyUnpicked) return '已取餐';
            if (anyPicked && anyUnpicked) return '部分取餐';
            return '未取餐';
        },
        pickupTagType(row) {
            const s = this.getPickupStatus(row);
            if (s === '已取餐') return 'success';
            if (s === '部分取餐') return 'warning';
            return 'danger';
        },
        treeNodeClick(data) {
            this.DepartmentId = data.Id;
            this.loadDinnerTimes(data.Id);
            this.handleQuery();
        },
        loadDinnerTimes(deptId) {
            getDinnerTimeList({ departmentId: deptId }).then(res => {
                const list = res.data ? (res.data.response || res.data || []) : [];
                this.dinnerTimeOptions = [{ label: '全部', value: 0 }, ...list.map(dt => ({
                    label: dt.DinnerTimeName,
                    value: dt.Id
                }))];
                // 更新 searchList 中的引用
                const dtItem = this.searchList.find(i => i.key === 'dinnerTimeId');
                if (dtItem) dtItem.options = this.dinnerTimeOptions;
            });
        },
        dialogCheck(selection, row) {
            this.currentRow = null;
            this.$refs.table.clearSelection();
            if (selection.length === 0) return;
            if (row) this.selectCurrentRow(row);
        },
        selectCurrentRow(val) {
            if (val) {
                this.currentRow = val;
                this.$refs.table.clearSelection();
                this.$refs.table.toggleRowSelection(val, true);
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = Array.isArray(val) ? val : [];
        },
        handleBatchCancelOrderStat() {
            if (!this.multipleSelection || this.multipleSelection.length === 0) {
                this.$message.warning('请选择要退订的订单');
                return;
            }

            // 前端先过滤已退订的订单，避免后端全失败导致提示不友好
            const ids = this.multipleSelection
                .filter(x => Number(x.OrderStatus) !== 1)
                .map(x => x.Id)
                .filter(id => id != null);

            if (!ids.length) {
                this.$message.warning('所选订单均已退订');
                return;
            }

            this.$confirm(`确定要批量退订 ${ids.length} 个订单吗？`, '提示', {
                type: 'warning'
            }).then(() => {
                batchCancelOrderStat(ids).then((res) => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '批量退订成功');
                        this.handleQuery();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '批量退订失败');
                    }
                }).catch(() => {
                    this.$message.error('批量退订失败');
                });
            }).catch(() => { });
        },

        // 兼容权限按钮事件：把配置的 handleDel 当作“批量退订”
        handleDel() {
            this.handleBatchCancelOrderStat();
        },
        callFunction(item) {
            this.currentDate = item.search && item.search.date || "";
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = { key: item.search };
            }
            if (this[item.Func]) this[item.Func].apply(this, item);
        },
        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.page = 1;
            this.handleQuery();
        },

        // 获取订餐统计（按部门）
        handleQuery() {
            const para = {
                page: this.page,
                pageSize: this.pageSize,
                departmentId: this.DepartmentId,
                startDate: this.filters.date || this.filters.startDate,
                endDate: this.filters.endDate || this.filters.endDate || this.filters.end,
                type: this.activeName,
                search: this.filters.search,
                pickupStatus: this.filters.pickupStatus,
                orderStatus: this.filters.orderStatus,
                dinnerTimeId: this.filters.dinnerTimeId
            };
            if (!para.departmentId) {
                this.$message.warning('请选择部门');
                return;
            }
            this.listLoading = true;
            getOrderStatsByDepartment(para).then(async (res) => {
                if (res.data && res.data.success) {
                    const resp = res.data.response || {};
                    this.total = resp.dataCount || resp.dataCount || (Array.isArray(resp.data) ? resp.data.length : 0);
                    const rows = resp.data || resp.data || res.data.response || [];
                    await this.prefetchListOssMedia(rows, 'MediaFiles');
                    this.users = rows;
                } else {
                    this.$message.error(res.data ? res.data.msg : '获取数据失败');
                }
            }).catch(() => {
                this.$message.error('获取数据出错');
            }).finally(() => {
                this.listLoading = false;
            });
        },

        openDetail(row) {
            if (!row) return;
            this.recordDetail = row;
            this.detailDialogVisible = true;
        },

        // 退订：调用后台批量退订接口（单条传入数组）
        handleCancelOrderStat(row) {
            if (!row || !row.Id) return;
            if (Number(row.OrderStatus) === 1) {
                this.$message.warning('该订单已退订');
                return;
            }

            this.$confirm('确定要退订该订单吗？', '提示', {
                type: 'warning'
            }).then(() => {
                batchCancelOrderStat([row.Id]).then((res) => {
                    if (res.data && res.data.success) {
                        this.$message.success(res.data.msg || '退订成功');
                        this.handleQuery();
                    } else {
                        this.$message.error(res.data ? res.data.msg : '退订失败');
                    }
                }).catch(() => {
                    this.$message.error('退订失败');
                });
            }).catch(() => { });
        },
        // 打开取餐明细弹窗，detail 为 UserDinnerTimeOrderDetail
        openPickupDetails(detail) {
            this.pickupLoading = true;
            try {
                this.pickupDetailList = (detail && detail.PickupDetails) ? detail.PickupDetails : [];
            } catch (e) {
                this.pickupDetailList = [];
            }
            this.pickupLoading = false;
            this.pickupDialogVisible = true;
        },

        // 导出 Excel
        exportExcel() {
            const para = {
                departmentId: this.DepartmentId,
                startDate: this.filters.date || this.filters.startDate || '',
                endDate: this.filters.endDate || '',
                type: this.activeName,
                search: this.filters.search,
                pickupStatus: this.filters.pickupStatus,
                orderStatus: this.filters.orderStatus
            };
            if (!para.departmentId) {
                this.$message.warning('请选择部门');
                return;
            }

            this.$message.info('正在准备导出，请稍候...');
            exportOrderStatsByDepartment(para).then((res) => {
                if (res.status === 200 && res.data) {
                    const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const downloadElement = document.createElement('a');
                    const href = window.URL.createObjectURL(blob);

                    // 构建文件名：角色_订餐明细_开始时间_结束时间
                    const roleName = this.activeName === '0' ? '学生' : '老师';
                    const sDate = para.startDate || '开始';
                    const eDate = para.endDate || '结束';
                    const fileName = `${roleName}_订餐明细_${sDate}_${eDate}.xlsx`;

                    downloadElement.href = href;
                    downloadElement.download = fileName;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    this.$message.success('导出成功');
                } else {
                    this.$message.error('导出失败');
                }
            }).catch(() => {
                this.$message.error('导出出错');
            });
        },
    },
    mounted() {
        let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (Array.isArray(this.searchList) && this.searchList.length >= 2) {
            this.filters.date = this.searchList[0].initValue || '';
            this.filters.endDate = this.searchList[1].initValue || '';
        }
    },
};
</script>

<style scoped>

.record-info {
    margin-bottom: 12px;
}

.record-info .muted {
    color: #606266;
    margin: 0 0 6px 0;
}

.batch-action-bar {
    margin: 10px 0;
    text-align: left;
}

.el-dialog__body {
    padding: 20px 28px;
}

.el-table th {
    background: #fafafa;
    color: #909399;
    font-weight: 600;
}

.el-table td {
    padding: 12px 10px;
}

.el-dialog__footer {
    padding: 12px 28px;
}

.order-action {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.order-action .el-button + .el-button {
    margin-left: 0;
}
</style>
